// Comprehensive country data for study abroad pages

export const countryDetails = {
  usa: {
    slug: "usa",
    name: "United States",
    code: "USA",
    flag: "https://flagcdn.com/w320/us.png",
    heroImage: "https://images.unsplash.com/photo-1570304816841-906a17d7b067?w=1920&q=80",
    tagline: "Home to the world's top-ranked universities and endless opportunities.",
    overview: "The United States is the world's most popular destination for international students, hosting over 1 million students annually. With 4,000+ accredited institutions, the US offers unmatched diversity in programs, research opportunities, and campus life. American degrees are recognized globally and open doors to career opportunities worldwide.",
    quickFacts: {
      capital: "Washington, D.C.",
      language: "English",
      currency: "US Dollar (USD)",
      population: "331 Million",
      avgTuition: "$20,000 - $60,000/year",
      livingCost: "$10,000 - $18,000/year",
      intakeSeasons: "Fall (Sep), Spring (Jan), Summer (May)",
      workPermit: "CPT/OPT up to 3 years",
    },
    visa: {
      type: "F-1 Student Visa",
      processingTime: "3-5 weeks",
      fee: "$185 (SEVIS: $350)",
      requirements: [
        "Valid passport (6+ months validity)",
        "I-20 form from SEVP-certified school",
        "Proof of financial support (bank statements, sponsor letter)",
        "Academic transcripts and mark sheets",
        "TOEFL/IELTS score report",
        "Standardized test scores (GRE/GMAT/SAT if applicable)",
        "Passport-size photographs",
        "Visa interview at US Embassy/Consulate",
        "Proof of ties to home country",
      ],
      tips: [
        "Apply at least 120 days before your program start date",
        "Be confident and concise during the visa interview",
        "Carry all original documents to the interview",
        "Demonstrate strong intent to return to home country",
      ],
    },
    universities: [
      {
        rank: 1,
        name: "Massachusetts Institute of Technology (MIT)",
        location: "Cambridge, Massachusetts",
        image: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?w=400&q=80",
        worldRanking: "#1 QS World",
        popularCourses: ["Computer Science", "Engineering", "Physics", "Mathematics"],
        tuitionRange: "$57,590/year",
        acceptanceRate: "4%",
        intlStudents: "33%",
      },
      {
        rank: 2,
        name: "Stanford University",
        location: "Stanford, California",
        image: "https://images.unsplash.com/photo-1579547945413-497e1b99dac0?w=400&q=80",
        worldRanking: "#2 QS World",
        popularCourses: ["Business", "Computer Science", "Medicine", "Law"],
        tuitionRange: "$56,169/year",
        acceptanceRate: "4%",
        intlStudents: "24%",
      },
      {
        rank: 3,
        name: "Harvard University",
        location: "Cambridge, Massachusetts",
        image: "https://images.unsplash.com/photo-1559135197-8a45ea74d367?w=400&q=80",
        worldRanking: "#4 QS World",
        popularCourses: ["Law", "Business (MBA)", "Medicine", "Economics"],
        tuitionRange: "$54,768/year",
        acceptanceRate: "3.4%",
        intlStudents: "25%",
      },
      {
        rank: 4,
        name: "California Institute of Technology (Caltech)",
        location: "Pasadena, California",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#6 QS World",
        popularCourses: ["Physics", "Engineering", "Astronomy", "Chemistry"],
        tuitionRange: "$58,680/year",
        acceptanceRate: "3%",
        intlStudents: "33%",
      },
      {
        rank: 5,
        name: "University of Chicago",
        location: "Chicago, Illinois",
        image: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?w=400&q=80",
        worldRanking: "#11 QS World",
        popularCourses: ["Economics", "Business", "Political Science", "Law"],
        tuitionRange: "$59,298/year",
        acceptanceRate: "5%",
        intlStudents: "28%",
      },
      {
        rank: 6,
        name: "Columbia University",
        location: "New York City, New York",
        image: "https://images.unsplash.com/photo-1613968317130-e6565f71b9d3?w=400&q=80",
        worldRanking: "#22 QS World",
        popularCourses: ["Journalism", "International Affairs", "Business", "Arts"],
        tuitionRange: "$63,530/year",
        acceptanceRate: "4%",
        intlStudents: "36%",
      },
      {
        rank: 7,
        name: "Yale University",
        location: "New Haven, Connecticut",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#16 QS World",
        popularCourses: ["Law", "Drama/Fine Arts", "Political Science", "History"],
        tuitionRange: "$59,950/year",
        acceptanceRate: "5%",
        intlStudents: "22%",
      },
      {
        rank: 8,
        name: "University of Pennsylvania",
        location: "Philadelphia, Pennsylvania",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#13 QS World",
        popularCourses: ["Business (Wharton)", "Nursing", "Engineering", "Communication"],
        tuitionRange: "$57,770/year",
        acceptanceRate: "6%",
        intlStudents: "22%",
      },
      {
        rank: 9,
        name: "Princeton University",
        location: "Princeton, New Jersey",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#17 QS World",
        popularCourses: ["Mathematics", "Physics", "Public Policy", "Economics"],
        tuitionRange: "$56,010/year",
        acceptanceRate: "4%",
        intlStudents: "24%",
      },
      {
        rank: 10,
        name: "Johns Hopkins University",
        location: "Baltimore, Maryland",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#28 QS World",
        popularCourses: ["Medicine", "Public Health", "Biomedical Engineering", "Nursing"],
        tuitionRange: "$58,720/year",
        acceptanceRate: "7%",
        intlStudents: "27%",
      },
    ],
    popularCourses: [
      { name: "Computer Science & IT", icon: "Monitor", demand: "Very High" },
      { name: "Business & MBA", icon: "Briefcase", demand: "Very High" },
      { name: "Engineering", icon: "Wrench", demand: "High" },
      { name: "Medicine & Health Sciences", icon: "Heart", demand: "High" },
      { name: "Data Science & AI", icon: "Brain", demand: "Very High" },
      { name: "Law (LLM)", icon: "Scale", demand: "Medium" },
      { name: "Architecture & Design", icon: "Landmark", demand: "Medium" },
      { name: "Finance & Economics", icon: "TrendingUp", demand: "High" },
    ],
  },

  canada: {
    slug: "canada",
    name: "Canada",
    code: "CAN",
    flag: "https://flagcdn.com/w320/ca.png",
    heroImage: "https://images.unsplash.com/photo-1517935706615-2717063c2225?w=1920&q=80",
    tagline: "Affordable excellence with world-class education and post-study work rights.",
    overview: "Canada is the third most popular destination for international students globally. Known for its high quality of life, multicultural society, and affordable tuition fees compared to the US and UK. Canadian degrees are globally recognized, and the country offers generous post-graduation work permits (PGWP) of up to 3 years, making it an excellent pathway to permanent residency.",
    quickFacts: {
      capital: "Ottawa",
      language: "English & French",
      currency: "Canadian Dollar (CAD)",
      population: "38 Million",
      avgTuition: "CAD 15,000 - 40,000/year",
      livingCost: "CAD 10,000 - 15,000/year",
      intakeSeasons: "Fall (Sep), Winter (Jan), Summer (May)",
      workPermit: "PGWP up to 3 years",
    },
    visa: {
      type: "Study Permit (Student Visa)",
      processingTime: "4-12 weeks",
      fee: "CAD 150",
      requirements: [
        "Letter of Acceptance from a DLI (Designated Learning Institution)",
        "Valid passport",
        "Proof of financial support (CAD 10,000+ for living + tuition)",
        "Language proficiency (IELTS 6.0+ / TOEFL 80+)",
        "Statement of Purpose (SOP)",
        "Academic transcripts and certificates",
        "Medical examination report",
        "Police clearance certificate",
        "Biometrics",
      ],
      tips: [
        "Apply through SDS (Student Direct Stream) for faster processing",
        "GIC (Guaranteed Investment Certificate) of CAD 10,000 speeds up the process",
        "Ensure your SOP clearly explains study plans and intent to return",
        "Have a strong financial profile showing sufficient funds",
      ],
    },
    universities: [
      {
        rank: 1,
        name: "University of Toronto",
        location: "Toronto, Ontario",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#21 QS World",
        popularCourses: ["Engineering", "Computer Science", "Medicine", "Business"],
        tuitionRange: "CAD 45,690/year",
        acceptanceRate: "43%",
        intlStudents: "26%",
      },
      {
        rank: 2,
        name: "University of British Columbia (UBC)",
        location: "Vancouver, British Columbia",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#34 QS World",
        popularCourses: ["Science", "Forestry", "Engineering", "Arts"],
        tuitionRange: "CAD 40,000/year",
        acceptanceRate: "52%",
        intlStudents: "28%",
      },
      {
        rank: 3,
        name: "McGill University",
        location: "Montreal, Quebec",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#30 QS World",
        popularCourses: ["Medicine", "Law", "Music", "Mining Engineering"],
        tuitionRange: "CAD 28,000/year",
        acceptanceRate: "46%",
        intlStudents: "30%",
      },
      {
        rank: 4,
        name: "University of Alberta",
        location: "Edmonton, Alberta",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#111 QS World",
        popularCourses: ["Engineering", "AI & Machine Learning", "Science", "Education"],
        tuitionRange: "CAD 29,500/year",
        acceptanceRate: "58%",
        intlStudents: "22%",
      },
      {
        rank: 5,
        name: "University of Waterloo",
        location: "Waterloo, Ontario",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#112 QS World",
        popularCourses: ["Computer Science", "Engineering", "Mathematics", "Co-op Programs"],
        tuitionRange: "CAD 36,000/year",
        acceptanceRate: "53%",
        intlStudents: "28%",
      },
      {
        rank: 6,
        name: "Western University",
        location: "London, Ontario",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#114 QS World",
        popularCourses: ["Business (Ivey)", "Medicine", "Law", "Health Sciences"],
        tuitionRange: "CAD 33,000/year",
        acceptanceRate: "56%",
        intlStudents: "18%",
      },
      {
        rank: 7,
        name: "University of Montreal",
        location: "Montreal, Quebec",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#141 QS World",
        popularCourses: ["AI Research", "Film Studies", "Dentistry", "Architecture"],
        tuitionRange: "CAD 25,000/year",
        acceptanceRate: "57%",
        intlStudents: "25%",
      },
      {
        rank: 8,
        name: "Queen's University",
        location: "Kingston, Ontario",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#209 QS World",
        popularCourses: ["Business (Smith)", "Engineering", "Law", "Public Policy"],
        tuitionRange: "CAD 35,000/year",
        acceptanceRate: "42%",
        intlStudents: "15%",
      },
      {
        rank: 9,
        name: "McMaster University",
        location: "Hamilton, Ontario",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#152 QS World",
        popularCourses: ["Health Sciences", "Engineering", "Business", "Social Sciences"],
        tuitionRange: "CAD 32,000/year",
        acceptanceRate: "58%",
        intlStudents: "20%",
      },
      {
        rank: 10,
        name: "University of Calgary",
        location: "Calgary, Alberta",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#182 QS World",
        popularCourses: ["Engineering", "Kinesiology", "Veterinary Medicine", "Energy"],
        tuitionRange: "CAD 26,000/year",
        acceptanceRate: "60%",
        intlStudents: "18%",
      },
    ],
    popularCourses: [
      { name: "Computer Science & IT", icon: "Monitor", demand: "Very High" },
      { name: "Business & Management", icon: "Briefcase", demand: "Very High" },
      { name: "Engineering", icon: "Wrench", demand: "High" },
      { name: "Health Sciences", icon: "Heart", demand: "High" },
      { name: "Data Science & AI", icon: "Brain", demand: "Very High" },
      { name: "Hospitality & Tourism", icon: "Utensils", demand: "Medium" },
      { name: "Environmental Science", icon: "Leaf", demand: "Medium" },
      { name: "Education", icon: "BookOpen", demand: "Medium" },
    ],
  },

  australia: {
    slug: "australia",
    name: "Australia",
    code: "AUS",
    flag: "https://flagcdn.com/w320/au.png",
    heroImage: "https://images.unsplash.com/photo-1523059623039-a9ed027e7fad?w=1920&q=80",
    tagline: "World-class education in a multicultural, vibrant environment.",
    overview: "Australia is home to 7 of the world's top 100 universities and offers a welcoming, multicultural environment. With a strong focus on research and innovation, Australian qualifications are recognized worldwide. The country offers excellent post-study work rights (2-6 years depending on qualification), competitive scholarships, and a high quality of life.",
    quickFacts: {
      capital: "Canberra",
      language: "English",
      currency: "Australian Dollar (AUD)",
      population: "26 Million",
      avgTuition: "AUD 20,000 - 50,000/year",
      livingCost: "AUD 21,041/year (govt. requirement)",
      intakeSeasons: "Feb (Main), Jul (Mid-year)",
      workPermit: "Post-study work visa 2-6 years",
    },
    visa: {
      type: "Subclass 500 Student Visa",
      processingTime: "4-6 weeks",
      fee: "AUD 710",
      requirements: [
        "Confirmation of Enrolment (CoE) from registered institution",
        "Valid passport",
        "Genuine Temporary Entrant (GTE) statement",
        "Financial capacity proof (AUD 21,041/year + tuition)",
        "English proficiency (IELTS 5.5-6.5 / PTE 42-58)",
        "Overseas Student Health Cover (OSHC)",
        "Academic transcripts and certificates",
        "Health examinations",
        "Character requirements (police check)",
      ],
      tips: [
        "Apply well in advance — processing can take 4-6 weeks",
        "GTE statement is crucial — explain your genuine intent to study",
        "Ensure OSHC covers your entire visa period",
        "Apply for scholarships early to reduce financial burden",
      ],
    },
    universities: [
      {
        rank: 1,
        name: "University of Melbourne",
        location: "Melbourne, Victoria",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#14 QS World",
        popularCourses: ["Arts", "Engineering", "Medicine", "Law"],
        tuitionRange: "AUD 38,000/year",
        acceptanceRate: "70%",
        intlStudents: "42%",
      },
      {
        rank: 2,
        name: "University of Sydney",
        location: "Sydney, New South Wales",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#18 QS World",
        popularCourses: ["Business", "Medicine", "Architecture", "Veterinary Science"],
        tuitionRange: "AUD 42,000/year",
        acceptanceRate: "30%",
        intlStudents: "38%",
      },
      {
        rank: 3,
        name: "Australian National University (ANU)",
        location: "Canberra, ACT",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#30 QS World",
        popularCourses: ["Politics", "International Relations", "Science", "Law"],
        tuitionRange: "AUD 39,000/year",
        acceptanceRate: "35%",
        intlStudents: "35%",
      },
      {
        rank: 4,
        name: "University of Queensland",
        location: "Brisbane, Queensland",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#40 QS World",
        popularCourses: ["Science", "Engineering", "Tourism", "Agriculture"],
        tuitionRange: "AUD 36,000/year",
        acceptanceRate: "55%",
        intlStudents: "30%",
      },
      {
        rank: 5,
        name: "UNSW Sydney",
        location: "Sydney, New South Wales",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#19 QS World",
        popularCourses: ["Engineering", "Business", "Law", "Design"],
        tuitionRange: "AUD 41,000/year",
        acceptanceRate: "30%",
        intlStudents: "36%",
      },
      {
        rank: 6,
        name: "Monash University",
        location: "Melbourne, Victoria",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#37 QS World",
        popularCourses: ["Pharmacy", "Engineering", "Education", "IT"],
        tuitionRange: "AUD 37,000/year",
        acceptanceRate: "50%",
        intlStudents: "40%",
      },
      {
        rank: 7,
        name: "University of Western Australia",
        location: "Perth, Western Australia",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#77 QS World",
        popularCourses: ["Mining Engineering", "Marine Science", "Agriculture", "Medicine"],
        tuitionRange: "AUD 33,000/year",
        acceptanceRate: "65%",
        intlStudents: "25%",
      },
      {
        rank: 8,
        name: "University of Adelaide",
        location: "Adelaide, South Australia",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#89 QS World",
        popularCourses: ["Wine Science", "Engineering", "Dentistry", "Computer Science"],
        tuitionRange: "AUD 35,000/year",
        acceptanceRate: "60%",
        intlStudents: "30%",
      },
      {
        rank: 9,
        name: "University of Technology Sydney (UTS)",
        location: "Sydney, New South Wales",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#88 QS World",
        popularCourses: ["IT", "Design", "Nursing", "Business"],
        tuitionRange: "AUD 34,000/year",
        acceptanceRate: "55%",
        intlStudents: "32%",
      },
      {
        rank: 10,
        name: "Macquarie University",
        location: "Sydney, New South Wales",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#130 QS World",
        popularCourses: ["Linguistics", "Business", "Media", "Environmental Science"],
        tuitionRange: "AUD 32,000/year",
        acceptanceRate: "62%",
        intlStudents: "35%",
      },
    ],
    popularCourses: [
      { name: "Engineering & Technology", icon: "Wrench", demand: "Very High" },
      { name: "Business & Management", icon: "Briefcase", demand: "Very High" },
      { name: "Information Technology", icon: "Monitor", demand: "High" },
      { name: "Health Sciences & Nursing", icon: "Heart", demand: "High" },
      { name: "Architecture & Design", icon: "Landmark", demand: "Medium" },
      { name: "Marine & Environmental Science", icon: "Leaf", demand: "Medium" },
      { name: "Hospitality & Tourism", icon: "Utensils", demand: "High" },
      { name: "Education & Teaching", icon: "BookOpen", demand: "Medium" },
    ],
  },

  germany: {
    slug: "germany",
    name: "Germany",
    code: "DEU",
    flag: "https://flagcdn.com/w320/de.png",
    heroImage: "https://images.unsplash.com/photo-1599946347371-68eb71b16afc?w=1920&q=80",
    tagline: "Tuition-free education at world-renowned universities in the heart of Europe.",
    overview: "Germany is Europe's top destination for international students, offering tuition-free education at most public universities. The country is home to over 400 institutions and is known for excellence in engineering, science, and technology. With a booming economy, students enjoy excellent job prospects and an 18-month post-study work visa to find employment.",
    quickFacts: {
      capital: "Berlin",
      language: "German (many programs in English)",
      currency: "Euro (EUR)",
      population: "84 Million",
      avgTuition: "€0 - €1,500/semester (public) | €10,000-20,000/year (private)",
      livingCost: "€10,332/year (blocked account requirement)",
      intakeSeasons: "Winter (Oct), Summer (Apr)",
      workPermit: "18-month job-seeker visa post-graduation",
    },
    visa: {
      type: "National Visa (Type D) for Study",
      processingTime: "6-12 weeks",
      fee: "€75",
      requirements: [
        "University admission letter / conditional offer",
        "Valid passport (minimum 12 months validity)",
        "Blocked account with €11,208 (proof of financial means)",
        "Health insurance coverage for Germany",
        "Academic transcripts with APS certificate (for some countries)",
        "Language proficiency (TestDaF/DSH for German or IELTS/TOEFL for English)",
        "Motivation letter",
        "Passport-size biometric photos",
        "Proof of accommodation in Germany",
      ],
      tips: [
        "Open a blocked account (Sperrkonto) well in advance",
        "APS certificate is mandatory for Indian students",
        "Apply for the visa at least 3 months before travel date",
        "Learning basic German (A1-B1) is highly recommended even for English programs",
      ],
    },
    universities: [
      {
        rank: 1,
        name: "Technical University of Munich (TUM)",
        location: "Munich, Bavaria",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#37 QS World",
        popularCourses: ["Engineering", "Computer Science", "Natural Sciences", "Management"],
        tuitionRange: "€0 (public) + €150/semester fees",
        acceptanceRate: "8%",
        intlStudents: "38%",
      },
      {
        rank: 2,
        name: "Ludwig Maximilian University (LMU Munich)",
        location: "Munich, Bavaria",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#54 QS World",
        popularCourses: ["Medicine", "Law", "Physics", "Philosophy"],
        tuitionRange: "€0 (public) + €150/semester fees",
        acceptanceRate: "20%",
        intlStudents: "18%",
      },
      {
        rank: 3,
        name: "Heidelberg University",
        location: "Heidelberg, Baden-Württemberg",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#47 QS World",
        popularCourses: ["Medicine", "Molecular Biology", "Physics", "German Literature"],
        tuitionRange: "€1,500/semester (non-EU) in BW",
        acceptanceRate: "15%",
        intlStudents: "20%",
      },
      {
        rank: 4,
        name: "Humboldt University of Berlin",
        location: "Berlin",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#120 QS World",
        popularCourses: ["Arts & Humanities", "Social Sciences", "Law", "Theology"],
        tuitionRange: "€0 (public) + €315/semester fees",
        acceptanceRate: "25%",
        intlStudents: "19%",
      },
      {
        rank: 5,
        name: "RWTH Aachen University",
        location: "Aachen, North Rhine-Westphalia",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#106 QS World",
        popularCourses: ["Mechanical Engineering", "Electrical Engineering", "Computer Science", "Materials Science"],
        tuitionRange: "€0 (public) + €300/semester fees",
        acceptanceRate: "30%",
        intlStudents: "27%",
      },
      {
        rank: 6,
        name: "Free University of Berlin",
        location: "Berlin",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#87 QS World",
        popularCourses: ["Political Science", "Film Studies", "Pharmacy", "Earth Sciences"],
        tuitionRange: "€0 (public) + €315/semester fees",
        acceptanceRate: "20%",
        intlStudents: "21%",
      },
      {
        rank: 7,
        name: "University of Freiburg",
        location: "Freiburg, Baden-Württemberg",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#192 QS World",
        popularCourses: ["Medicine", "Biology", "Environmental Science", "History"],
        tuitionRange: "€1,500/semester (non-EU)",
        acceptanceRate: "28%",
        intlStudents: "19%",
      },
      {
        rank: 8,
        name: "University of Göttingen",
        location: "Göttingen, Lower Saxony",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#232 QS World",
        popularCourses: ["Physics", "Mathematics", "Chemistry", "Agricultural Sciences"],
        tuitionRange: "€0 (public) + €400/semester fees",
        acceptanceRate: "35%",
        intlStudents: "17%",
      },
      {
        rank: 9,
        name: "University of Hamburg",
        location: "Hamburg",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#205 QS World",
        popularCourses: ["Physics", "Climate Research", "Economics", "Law"],
        tuitionRange: "€0 (public) + €335/semester fees",
        acceptanceRate: "32%",
        intlStudents: "16%",
      },
      {
        rank: 10,
        name: "TU Berlin",
        location: "Berlin",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#154 QS World",
        popularCourses: ["Engineering", "Computer Science", "Architecture", "Urban Planning"],
        tuitionRange: "€0 (public) + €315/semester fees",
        acceptanceRate: "22%",
        intlStudents: "25%",
      },
    ],
    popularCourses: [
      { name: "Engineering & Technology", icon: "Wrench", demand: "Very High" },
      { name: "Computer Science & AI", icon: "Monitor", demand: "Very High" },
      { name: "Automotive Engineering", icon: "Car", demand: "High" },
      { name: "Medicine & Life Sciences", icon: "Heart", demand: "High" },
      { name: "Business & Economics", icon: "Briefcase", demand: "High" },
      { name: "Environmental Science", icon: "Leaf", demand: "Medium" },
      { name: "Architecture", icon: "Landmark", demand: "Medium" },
      { name: "Physics & Mathematics", icon: "Brain", demand: "Medium" },
    ],
  },

  italy: {
    slug: "italy",
    name: "Italy",
    code: "ITA",
    flag: "https://flagcdn.com/w320/it.png",
    heroImage: "https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=1920&q=80",
    tagline: "Study in the birthplace of Renaissance — art, culture, and academic excellence.",
    overview: "Italy boasts some of the oldest and most prestigious universities in the world, including the University of Bologna, founded in 1088. Known for excellence in design, architecture, fashion, engineering, and arts, Italy offers affordable tuition at public universities. The country's rich cultural heritage, beautiful landscapes, and central European location make it a unique study destination.",
    quickFacts: {
      capital: "Rome",
      language: "Italian (English programs available)",
      currency: "Euro (EUR)",
      population: "60 Million",
      avgTuition: "€900 - €4,000/year (public) | €10,000 - 25,000/year (private)",
      livingCost: "€700 - €1,200/month",
      intakeSeasons: "September (Main), February",
      workPermit: "12-month job-seeker extension after graduation",
    },
    visa: {
      type: "Type D Student Visa (Visto per Studio)",
      processingTime: "4-8 weeks",
      fee: "€50",
      requirements: [
        "University admission/pre-enrollment letter",
        "Valid passport (3+ months beyond visa expiry)",
        "Financial proof (€6,000+ per year or scholarship)",
        "Health insurance valid in Italy",
        "Academic transcripts with Declaration of Value (Dichiarazione di Valore)",
        "Language proficiency (Italian B2 or IELTS 5.5+ for English)",
        "Proof of accommodation in Italy",
        "Return flight ticket or itinerary",
        "Passport-size photos",
      ],
      tips: [
        "Apply for pre-enrollment through the Italian Embassy well in advance",
        "Declaration of Value must be obtained from the Italian Consulate",
        "Learning basic Italian is helpful even for English-taught programs",
        "Apply for DSU (regional scholarship) for fee waivers and housing",
      ],
    },
    universities: [
      {
        rank: 1,
        name: "Politecnico di Milano",
        location: "Milan, Lombardy",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#111 QS World",
        popularCourses: ["Engineering", "Architecture", "Design", "Urban Planning"],
        tuitionRange: "€3,886/year (public)",
        acceptanceRate: "20%",
        intlStudents: "25%",
      },
      {
        rank: 2,
        name: "University of Bologna",
        location: "Bologna, Emilia-Romagna",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#150 QS World",
        popularCourses: ["Law", "Arts & Humanities", "Political Science", "Medicine"],
        tuitionRange: "€2,500/year (public)",
        acceptanceRate: "55%",
        intlStudents: "15%",
      },
      {
        rank: 3,
        name: "Sapienza University of Rome",
        location: "Rome, Lazio",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#132 QS World",
        popularCourses: ["Medicine", "Engineering", "Architecture", "Classics"],
        tuitionRange: "€2,900/year (public)",
        acceptanceRate: "60%",
        intlStudents: "12%",
      },
      {
        rank: 4,
        name: "University of Padua",
        location: "Padua, Veneto",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#219 QS World",
        popularCourses: ["Medicine", "Science", "Psychology", "Agriculture"],
        tuitionRange: "€2,600/year (public)",
        acceptanceRate: "50%",
        intlStudents: "10%",
      },
      {
        rank: 5,
        name: "University of Milan",
        location: "Milan, Lombardy",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#205 QS World",
        popularCourses: ["Medicine", "Arts", "Pharmacology", "Veterinary Science"],
        tuitionRange: "€2,500/year (public)",
        acceptanceRate: "45%",
        intlStudents: "14%",
      },
      {
        rank: 6,
        name: "Politecnico di Torino",
        location: "Turin, Piedmont",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#241 QS World",
        popularCourses: ["Engineering", "Architecture", "Automotive Design", "Aerospace"],
        tuitionRange: "€3,500/year (public)",
        acceptanceRate: "30%",
        intlStudents: "22%",
      },
      {
        rank: 7,
        name: "University of Florence",
        location: "Florence, Tuscany",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#296 QS World",
        popularCourses: ["Art History", "Architecture", "Agriculture", "Humanities"],
        tuitionRange: "€2,200/year (public)",
        acceptanceRate: "55%",
        intlStudents: "12%",
      },
      {
        rank: 8,
        name: "University of Pisa",
        location: "Pisa, Tuscany",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#328 QS World",
        popularCourses: ["Science", "Engineering", "Mathematics", "Computer Science"],
        tuitionRange: "€2,400/year (public)",
        acceptanceRate: "50%",
        intlStudents: "10%",
      },
      {
        rank: 9,
        name: "Bocconi University",
        location: "Milan, Lombardy",
        image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?w=400&q=80",
        worldRanking: "#7 QS (Business)",
        popularCourses: ["Business", "Finance", "Economics", "Management"],
        tuitionRange: "€14,000/year (private)",
        acceptanceRate: "15%",
        intlStudents: "30%",
      },
      {
        rank: 10,
        name: "University of Turin",
        location: "Turin, Piedmont",
        image: "https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=400&q=80",
        worldRanking: "#348 QS World",
        popularCourses: ["Science", "Arts & Philosophy", "Agriculture", "Biotechnology"],
        tuitionRange: "€2,300/year (public)",
        acceptanceRate: "58%",
        intlStudents: "11%",
      },
    ],
    popularCourses: [
      { name: "Fashion & Design", icon: "Palette", demand: "Very High" },
      { name: "Architecture", icon: "Landmark", demand: "Very High" },
      { name: "Engineering", icon: "Wrench", demand: "High" },
      { name: "Business & Finance", icon: "Briefcase", demand: "High" },
      { name: "Art History & Fine Arts", icon: "Paintbrush", demand: "High" },
      { name: "Medicine", icon: "Heart", demand: "High" },
      { name: "Culinary Arts & Food Science", icon: "Utensils", demand: "Medium" },
      { name: "Automotive Engineering", icon: "Car", demand: "Medium" },
    ],
  },
};

export const countrySlugs = ["usa", "canada", "australia", "germany", "italy"];

export const countryNavItems = [
  { name: "USA", slug: "usa", flag: "https://flagcdn.com/w40/us.png" },
  { name: "Canada", slug: "canada", flag: "https://flagcdn.com/w40/ca.png" },
  { name: "Australia", slug: "australia", flag: "https://flagcdn.com/w40/au.png" },
  { name: "Germany", slug: "germany", flag: "https://flagcdn.com/w40/de.png" },
  { name: "Italy", slug: "italy", flag: "https://flagcdn.com/w40/it.png" },
];
